
















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { HeaderList } from '@/components/Table/TableModel';

import Table from '@/components/molecules/Table/Table.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';

import AdminService from '@/api/AdminService';
import DateUtils from '@/utils/DateUtils';
import { Pagination, SortController } from '@/utils/Pagination';
import { IPeriod } from '@/models/period';

@Component({ components: { Table, TableHeader, TableRow, TableCell } })
export default class BusinessDetailTransactionsList extends Vue {
  @Prop(String) readonly businessId?: string;
  @Prop() readonly period?: IPeriod;

  service: AdminService = new AdminService();
  pagination = new Pagination(this.formatRow);
  sort = new SortController();
  query: any = {
    searchableFields: 'business.id',
    search: this.businessId
  };
  headers = [
    new HeaderList(
      `Provider`,
      'connectTransaction.provider',
      '12px 12px 12px 32px'
    ),
    new HeaderList(`Value`, 'connectTransaction.moneyAmount', '12px', 'right'),
    new HeaderList(`Coins`, 'connectTransaction.coinsAmount', '12px', 'right'),
    new HeaderList(`Customer`, 'customer.name', '12px'),
    new HeaderList(
      `Date`,
      'connectTransaction.createdAt',
      '12px 32px 12px 12px'
    )
  ];

  updateSort(field: string) {
    this.sort.update(field);
    this.query = {
      ...this.query,
      sort: this.sort.toString()
    };
  }

  getCardType(cardType: string) {
    switch (cardType) {
      case 'master':
        return 'mastercard';

      default:
        return cardType;
    }
  }

  @Watch('query')
  refreshPagination(query: any) {
    this.pagination.refresh(
      `/super-admin/merchant-connect/transactions/${this.businessId}`,
      query
    );
  }

  @Watch('period')
  updatePeriod() {
    this.query = {
      ...this.query,
      ...(this.period ? { from: this.period.start } : {}),
      ...(this.period ? { to: this.period.end } : {})
    };
  }

  mounted() {
    this.updatePeriod();
    this.pagination.setPaginationTarget(this.$refs.target as HTMLElement);
  }

  formatRow(row: any) {
    return {
      id: row.id,
      provider: row.provider,
      value: `${this.formatNumber(row.moneyAmount)} ${row.moneyCurrency}`,
      coins: this.formatNumber(row.coinsAmount),
      customer: row.customer.name
        ? `${row.customer.name} ${row.customer.lastname}`
        : '-',
      date: DateUtils.formatISODate(row.createdAt),
      status: row.status
    };
  }

  formatNumber(value: string | number = 0) {
    if (typeof value === 'string') {
      value = parseInt(value, 10);
    }
    return (value / 100).toLocaleString();
  }
}
